import React, { PropsWithChildren } from 'react';
import type { CookieFlag } from 'utils/cookie';

export type CookieGateProps = {
  cookieState: CookieFlag;
};

/**
 * A higher-order-component that prevents rendering children if
 * the given cookie is truthy.
 *
 * Used with things like tooltips or announcements.
 * @param cookie
 * @param children
 * @constructor
 */
export function CookieGate({ cookieState, children }: PropsWithChildren<CookieGateProps>) {
  if (cookieState.expired || cookieState.value) {
    return null;
  }

  return <>{children}</>;
}
